import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import LinearProgress from "@material-ui/core/LinearProgress";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { grey } from "@mui/material/colors";

import "./DialogHoneyLoad.scss";

import runtimeEnv from "@mars/heroku-js-runtime-env";
import fetchAPI from "../../../../components/utils/fetchAPI";

const env = runtimeEnv();
export default class DialogHoneyLoad extends Component {
  state = {
    localControl: true,
    message:
      typeof this.props.message !== "undefined" ? this.props.message : "",
    parstData:
      typeof this.props.dataParts !== "undefined" ? this.props.dataParts : "",
    buttonCancel:
      typeof this.props.buttonCancel !== "undefined"
        ? this.props.buttonCancel
        : false,
    buttonAccept:
      typeof this.props.buttonAccept !== "undefined"
        ? this.props.buttonAccept
        : true,
    buttonDownload:
      typeof this.props.buttonDownload !== "undefined"
        ? this.props.buttonDownload
        : false,
    buttonCancelText:
      typeof this.props.buttonCancelText !== "undefined"
        ? this.props.buttonCancelText
        : "Cancelar",
    buttonAcceptText:
      typeof this.props.buttonAcceptText !== "undefined"
        ? this.props.buttonAcceptText
        : "Aceptar",
    buttonDownloadText:
      typeof this.props.buttonDownloadText !== "undefined"
        ? this.props.buttonDownloadText
        : "Descargar",
    showIcon:
      typeof this.props.showIcon !== "undefined" ? this.props.showIcon : false,
    iconType:
      typeof this.props.iconType !== "undefined"
        ? this.props.iconType
        : "warning",
    showMessage:
      typeof this.props.showMessage !== "undefined"
        ? this.props.showMessage
        : true,
    showProgress:
      typeof this.props.showProgress !== "undefined"
        ? this.props.showProgress
        : false,
    showActions:
      typeof this.props.showActions !== "undefined"
        ? this.props.showActions
        : true,
    checked: [],
    dataPart: [],
  };

  closeModal = () => {
    this.setState({
      localControl: false,
    });
  };

  handleChecked = (data) => (event, i) => {
    const valueCheck = event.target.checked;
    if (valueCheck) {
      this.setState({
        checked: [...this.state.checked, data],
      });
    } else {
      this.setState({
        checked: this.state.checked.filter((element) => element !== data),
      });
    }
  };

  recursiveDownload = async (elements, element, index, serviceURL) => {
    if (!element) {
      this.setState({
        checked: [],
      });
      this.props.closeModalGeneral();
      return;
    }
    let service = `${serviceURL}`;
    service = service.replace("<archiveId>", element.partId);

    fetchAPI({
      protocol: "GET",
      service: service,
      download: true,
      codeCountry: this.props.countriesCode,
      archiveName: `consolidadoExclusiones - Clientes del ${
        this.state.checked[index].partId > 1
          ? (this.state.checked[index].partId - 1) * 30000
          : 1
      } al ${this.state.checked[index].partId * 30000}.csv`,
      callbackThen: () => {
        return this.recursiveDownload(
          elements,
          elements[index + 1],
          index + 1,
          serviceURL
        );
      },
      callbackError: () => {
        return this.recursiveDownload(
          elements,
          elements[index + 1],
          index + 1,
          serviceURL
        );
      },
    });
  };

  handleDownload = async () => {
    let serviceURL = this.props.isException
      ? env.REACT_APP_SERVICES_GET_PARST_CONSOLIDATE_EXCEPTION_DOWNLOAD
      : env.REACT_APP_SERVICES_GET_PARST_CONSOLIDATE_DOWNLOAD;

    serviceURL = serviceURL.replace("<countryCode>", this.props.countriesCode);
    serviceURL = serviceURL.replace("<bacthId>", this.props.bacthId);
    this.props.showLoading();
    this.setState({
      localControl: false,
    });

    if (this.state.checked && this.state.checked.length > 0) {
      setTimeout(async () => {
        await this.recursiveDownload(
          this.state.checked,
          this.state.checked[0],
          0,
          serviceURL,
          false
        );
      }, 500);
    }
  };

  onCloseModal = (e) => {
    this.setState({
      checked: [],
    });
    this.props.handleClose(e);
  };
  render() {
    return (
      <Dialog onClose={this.onCloseModal} open={this.props.opened}>
        <Grid
          container
          item
          xs={12}
          spacing={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            {this.state.showIcon ? (
              <div
                className={"dialog__icon dialog__icon--" + this.state.iconType}
              ></div>
            ) : null}
          </Grid>
          <Grid item xs={12}>
            {this.props.messageDataParst ? (
              this.props.messageDataParst.map((message, index) => {
                return <div className={"dialog__message"}>{message}</div>;
              })
            ) : this.state.showMessage ? (
              <div className={"dialog__message"}>{this.props.message}</div>
            ) : null}
          </Grid>
          {this.props.dataParts
            ? this.props.dataParts.map((part, index) => {
                return (
                  <Grid item xs={12}>
                    <br />
                    <FormGroup className={"dialog__message"}>
                      <FormControlLabel
                        className={"dialog__message"}
                        control={
                          <Checkbox
                            checked={this.state.checked.includes(part)}
                            onChange={this.handleChecked(part, index)}
                            inputProps={{ "aria-label": "controlled" }}
                            sx={{
                              color: grey[900],
                              "&.Mui-checked": {
                                color: grey[900],
                              },
                            }}
                          />
                        }
                        label={
                          <span>
                            <strong>{`Grupo ${index + 1}`}</strong>
                            {` - de ${index > 0 ? index * 30000 : 1} a ${
                              (index + 1) * 30000
                            } clientes`}
                          </span>
                        }
                      />
                    </FormGroup>
                  </Grid>
                );
              })
            : null}

          <Grid item xs={12}>
            {this.state.showProgress ? (
              <div className={"dialog__progress"}>
                <LinearProgress
                  variant="determinate"
                  value={this.props.progress}
                />
              </div>
            ) : null}
          </Grid>

          <Grid item xs={12}>
            {this.state.showMessage ? (
              <div className={"dialog__actions"}>
                {this.state.buttonCancel ? (
                  <button
                    className="dialog__button dialog__button--cancel"
                    onClick={this.props.onClickCancel}
                  >
                    {this.state.buttonCancelText}
                  </button>
                ) : null}
                {this.state.buttonAccept ? (
                  <button
                    className="dialog__button dialog__button--accept"
                    onClick={this.props.onClickAccept}
                  >
                    {this.state.buttonAcceptText}
                  </button>
                ) : null}
                {this.state.buttonDownload ? (
                  <button
                    className="dialog__button dialog__button--download"
                    onClick={this.handleDownload}
                  >
                    {this.state.buttonDownloadText}
                  </button>
                ) : null}
              </div>
            ) : null}
          </Grid>
        </Grid>
      </Dialog>
    );
  }
}
